import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { ApiService } from './core/api.service';
import { AuthgaurdService } from './core/security/authgaurd.service';
import { FunctionsService } from './core/global/functions.service';
import { UtilityService } from './core/global/utility.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgxSpinnerModule } from "ngx-spinner";
import { ChartsModule } from 'ng2-charts';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ProgressBarModule } from "angular-progress-bar";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './shared/header/header.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { OrganizationComponent } from './pages/organization/organization.component';
import { OrganizationAddModelComponent } from './pages/organization-add-model/organization-add-model.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatNativeDateModule } from '@angular/material/core'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms'
import { ProfileModelComponent } from "./pages/profile-model/profile-model.component";
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { GateComponent } from './pages/gate/gate.component';
import { GateAddModelComponent } from './pages/gate-add-model/gate-add-model.component';
import { UserAddModelComponent } from './pages/users/user-add-model/user-add-model.component';
import { UserComponent } from './pages/users/user/user.component';
import { UserQrGeneratorModelComponent } from './pages/users/user-qr-generator-model/user-qr-generator-model.component';
import { UserDashboardComponent } from './pages/users/user-dashboard/user-dashboard.component';
import { UsersDetailsComponent } from './pages/users/users-details/users-details.component';
import { UserRoleAddModelComponent } from './pages/users/user-role-add-model/user-role-add-model.component';
import { UserRoleDetailsComponent } from './pages/users/user-role-details/user-role-details.component';
import { UserEventPageComponent } from './pages/users/user-event-page/user-event-page.component';
import { UserLandingPageComponent } from './pages/users/user-landing-page/user-landing-page.component';
import { AboutUsComponent } from './pages/users/about-us/about-us.component';
import { AboutUsAddModelComponent } from './pages/users/about-us-add-model/about-us-add-model.component';
import { NgxEditorModule } from 'ngx-editor';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { AboutUsViewComponent } from './pages/users/about-us-view/about-us-view.component';
import { UserRoleViewComponent } from './pages/users/user-role-view/user-role-view.component';
import { UploadCsvModalComponent } from './pages/upload-csv-modal/upload-csv-modal.component';
import { RichTextAreaComponent } from './pages/rich-text-area/rich-text-area.component';
import { LightboxModule } from 'ngx-lightbox';
import { DinningTimeComponent } from './pages/users/dinning-time/dinning-time.component';
import { DiningTimeAddModalComponent } from './pages/users/dining-time-add-modal/dining-time-add-modal.component';
@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HeaderComponent,
        HomeComponent,
        AboutComponent,
        SidebarComponent,
        FooterComponent,
        OrganizationComponent,
        ProfileModelComponent,
        ForgotPasswordComponent,
        ChangePasswordComponent,
        OrganizationAddModelComponent,
        GateComponent,
        GateAddModelComponent,
        UserAddModelComponent,
        UserComponent,
        UserQrGeneratorModelComponent,
        UserDashboardComponent,
        UsersDetailsComponent,
        UserRoleAddModelComponent,
        UserRoleDetailsComponent,
        UserEventPageComponent,
        UserLandingPageComponent,
        AboutUsComponent,
        AboutUsAddModelComponent,
        AboutUsViewComponent,
        UserRoleViewComponent,
        UploadCsvModalComponent,
        RichTextAreaComponent,
        DinningTimeComponent,
        DiningTimeAddModalComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        NgSelectModule,
        FormsModule,
        NgbModule,
        NgxDropzoneModule,
        NgxSpinnerModule,
        Ng2SearchPipeModule,
        NgxPaginationModule,
        ChartsModule,
        DragDropModule,
        ProgressBarModule,
        SignaturePadModule,
        FormsModule,
        LightboxModule,
        MatDatepickerModule,
        MatInputModule,
        MatFormFieldModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        NgxDocViewerModule,
        NgxEditorModule,
        AngularEditorModule,
        NgxDaterangepickerMd.forRoot(),
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            easing: 'ease-in',
            timeOut: 4000,
            preventDuplicates: true,
        }),
        // NgxCaptureModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }, { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } }, ApiService, AuthgaurdService, FunctionsService, UtilityService],
    bootstrap: [AppComponent]
})
export class AppModule { MatInputModule }

